import { ReportCard, ReportPriceRow } from "~/components/report";
import { useT } from "@repo/transifex";
import { useVatLabel } from "~/hooks/use-vat-label";

import { type DiscountsSectionData } from "./types";
import { negatePrice } from "./utils";

type DiscountsSectionProps = {
  data: DiscountsSectionData;
};

export const DiscountsSection = ({ data }: DiscountsSectionProps) => {
  const t = useT();
  const { vatLabel } = useVatLabel();

  return (
    <ReportCard title={t("Discounts (incl. {vatLabel})", { vatLabel })}>
      {data.items.map((item) => (
        <ReportPriceRow
          key={item.name}
          label={item.name}
          value={negatePrice(item.amount)}
          currency={data.currency}
        />
      ))}
      <ReportPriceRow
        label="TOTAL"
        value={negatePrice(data.total)}
        currency={data.currency}
        variant="bold"
      />
    </ReportCard>
  );
};
